import Vue from 'vue';
// @ts-ignore
import Swiper from 'swiper/swiper-bundle.esm.browser.min.js';
import 'swiper/swiper-bundle.min.css';
const getFormattedEventName = (eventName) => {
    let clippedName = eventName.replace('on', '');
    clippedName = clippedName[0].toLowerCase() + clippedName.substring(1, clippedName.length);
    return clippedName;
};
export default Vue.extend({
    name: 'SwiperComponent',
    props: {
        modules: {
            type: Array,
            default: undefined
        },
        init: {
            type: Boolean,
            default: undefined
        },
        direction: {
            type: String,
            default: undefined
        },
        touchEventsTarget: {
            type: String,
            default: undefined
        },
        initialSlide: {
            type: Number,
            default: undefined
        },
        speed: {
            type: Number,
            default: undefined
        },
        cssMode: {
            type: Boolean,
            default: undefined
        },
        updateOnWindowResize: {
            type: Boolean,
            default: undefined
        },
        resizeObserver: {
            type: Boolean,
            default: undefined
        },
        nested: {
            type: Boolean,
            default: undefined
        },
        focusableElements: {
            type: String,
            default: undefined
        },
        width: {
            type: [Number, String],
            default: undefined
        },
        height: {
            type: [Number, String],
            default: undefined
        },
        preventInteractionOnTransition: {
            type: Boolean,
            default: undefined
        },
        userAgent: {
            type: String,
            default: undefined
        },
        url: {
            type: String,
            default: undefined
        },
        edgeSwipeDetection: {
            type: [Boolean, String],
            default: undefined
        },
        edgeSwipeThreshold: {
            type: Number,
            default: undefined
        },
        autoHeight: {
            type: Boolean,
            default: undefined
        },
        setWrapperSize: {
            type: Boolean,
            default: undefined
        },
        virtualTranslate: {
            type: Boolean,
            default: undefined
        },
        effect: {
            type: String,
            default: undefined
        },
        breakpoints: {
            type: Object,
            default: undefined
        },
        spaceBetween: {
            type: Number,
            default: undefined
        },
        slidesPerView: {
            type: [Number, String],
            default: undefined
        },
        slidesPerGroup: {
            type: Number,
            default: undefined
        },
        slidesPerGroupSkip: {
            type: Number,
            default: undefined
        },
        slidesPerGroupAuto: {
            type: Boolean,
            default: undefined
        },
        centeredSlides: {
            type: Boolean,
            default: undefined
        },
        centeredSlidesBounds: {
            type: Boolean,
            default: undefined
        },
        slidesOffsetBefore: {
            type: Number,
            default: undefined
        },
        slidesOffsetAfter: {
            type: Number,
            default: undefined
        },
        normalizeSlideIndex: {
            type: Boolean,
            default: undefined
        },
        centerInsufficientSlides: {
            type: Boolean,
            default: undefined
        },
        watchOverflow: {
            type: Boolean,
            default: undefined
        },
        roundLengths: {
            type: Boolean,
            default: undefined
        },
        touchRatio: {
            type: Number,
            default: undefined
        },
        touchAngle: {
            type: Number,
            default: undefined
        },
        simulateTouch: {
            type: Boolean,
            default: undefined
        },
        shortSwipes: {
            type: Boolean,
            default: undefined
        },
        longSwipes: {
            type: Boolean,
            default: undefined
        },
        longSwipesRatio: {
            type: Number,
            default: undefined
        },
        longSwipesMs: {
            type: Number,
            default: undefined
        },
        followFinger: {
            type: Boolean,
            default: undefined
        },
        allowTouchMove: {
            type: Boolean,
            default: undefined
        },
        threshold: {
            type: Number,
            default: undefined
        },
        touchMoveStopPropagation: {
            type: Boolean,
            default: undefined
        },
        touchStartPreventDefault: {
            type: Boolean,
            default: undefined
        },
        touchStartForcePreventDefault: {
            type: Boolean,
            default: undefined
        },
        touchReleaseOnEdges: {
            type: Boolean,
            default: undefined
        },
        uniqueNavElements: {
            type: Boolean,
            default: undefined
        },
        resistance: {
            type: Boolean,
            default: undefined
        },
        resistanceRatio: {
            type: Number,
            default: undefined
        },
        watchSlidesProgress: {
            type: Boolean,
            default: undefined
        },
        grabCursor: {
            type: Boolean,
            default: undefined
        },
        preventClicks: {
            type: Boolean,
            default: undefined
        },
        preventClicksPropagation: {
            type: Boolean,
            default: undefined
        },
        slideToClickedSlide: {
            type: Boolean,
            default: undefined
        },
        preloadImages: {
            type: Boolean,
            default: undefined
        },
        updateOnImagesReady: {
            type: Boolean,
            default: undefined
        },
        loop: {
            type: Boolean,
            default: undefined
        },
        loopAdditionalSlides: {
            type: Number,
            default: undefined
        },
        loopedSlides: {
            type: Number,
            default: undefined
        },
        loopFillGroupWithBlank: {
            type: Boolean,
            default: undefined
        },
        loopPreventsSlide: {
            type: Boolean,
            default: undefined
        },
        allowSlidePrev: {
            type: Boolean,
            default: undefined
        },
        allowSlideNext: {
            type: Boolean,
            default: undefined
        },
        swipeHandler: {
            type: Boolean,
            default: undefined
        },
        noSwiping: {
            type: Boolean,
            default: undefined
        },
        noSwipingClass: {
            type: String,
            default: undefined
        },
        noSwipingSelector: {
            type: String,
            default: undefined
        },
        passiveListeners: {
            type: Boolean,
            default: undefined
        },
        containerModifierClass: {
            type: String,
            default: undefined
        },
        slideClass: {
            type: String,
            default: undefined
        },
        slideBlankClass: {
            type: String,
            default: undefined
        },
        slideActiveClass: {
            type: String,
            default: undefined
        },
        slideDuplicateActiveClass: {
            type: String,
            default: undefined
        },
        slideVisibleClass: {
            type: String,
            default: undefined
        },
        slideDuplicateClass: {
            type: String,
            default: undefined
        },
        slideNextClass: {
            type: String,
            default: undefined
        },
        slideDuplicateNextClass: {
            type: String,
            default: undefined
        },
        slidePrevClass: {
            type: String,
            default: undefined
        },
        slideDuplicatePrevClass: {
            type: String,
            default: undefined
        },
        wrapperClass: {
            type: String,
            default: undefined
        },
        runCallbacksOnInit: {
            type: Boolean,
            default: undefined
        },
        observer: {
            type: Boolean,
            default: undefined
        },
        observeParents: {
            type: Boolean,
            default: undefined
        },
        observeSlideChildren: {
            type: Boolean,
            default: undefined
        },
        a11y: {
            type: [Boolean, Object],
            default: undefined
        },
        autoplay: {
            type: [Boolean, Object],
            default: undefined
        },
        controller: {
            type: Object,
            default: undefined
        },
        coverflowEffect: {
            type: Object,
            default: undefined
        },
        cubeEffect: {
            type: Object,
            default: undefined
        },
        fadeEffect: {
            type: Object,
            default: undefined
        },
        flipEffect: {
            type: Object,
            default: undefined
        },
        creativeEffect: {
            type: Object,
            default: undefined
        },
        cardsEffect: {
            type: Object,
            default: undefined
        },
        hashNavigation: {
            type: [Boolean, Object],
            default: undefined
        },
        history: {
            type: [Boolean, Object],
            default: undefined
        },
        keyboard: {
            type: [Boolean, Object],
            default: undefined
        },
        lazy: {
            type: [Boolean, Object],
            default: undefined
        },
        mousewheel: {
            type: [Boolean, Object],
            default: undefined
        },
        navigation: {
            type: [Boolean, Object],
            default: undefined
        },
        pagination: {
            type: [Boolean, Object],
            default: undefined
        },
        parallax: {
            type: [Boolean, Object],
            default: undefined
        },
        scrollbar: {
            type: [Boolean, Object],
            default: undefined
        },
        thumbs: {
            type: Object,
            default: undefined
        },
        virtual: {
            type: [Boolean, Object],
            default: undefined
        },
        zoom: {
            type: [Boolean, Object],
            default: undefined
        },
        grid: {
            type: [Object],
            default: undefined
        },
        freeMode: {
            type: [Boolean, Object],
            default: undefined
        }
    },
    data: () => ({
        swiperInstance: null,
        inited: false,
        updated: false
    }),
    mounted() {
        const { swiper } = this.$refs;
        const vm = this;
        setTimeout(() => {
            vm.swiperInstance.init(swiper);
        }, 500);
    },
    methods: {
        updateSwiper() {
            const vm = this;
            if (vm.inited) {
                if (!vm.updated) {
                    if (vm.loop) {
                        vm.swiperInstance.loopDestroy();
                        vm.updated = true;
                        setTimeout(() => {
                            vm.swiperInstance.loopCreate();
                        }, 5);
                        setTimeout(() => {
                            vm.updated = false;
                        }, 100);
                    }
                    else {
                        vm.swiperInstance.update();
                        vm.updated = true;
                        setTimeout(() => {
                            vm.updated = false;
                        }, 100);
                    }
                }
            }
        },
        updateSwiperSlides() {
            if (this.swiperInstance) {
                setTimeout(() => {
                    this.swiperInstance.scrollbar.updateSize();
                }, 500);
            }
        }
    },
    created() {
        const vm = this;
        const options = {};
        for (const option in vm.$options.propsData) {
            if (vm[option]) {
                options[option] = vm[option];
            }
        }
        options.observer = true;
        vm.swiperInstance = new Swiper(options);
        vm.swiperInstance.on('afterInit', () => {
            setTimeout(() => {
                vm.inited = true;
            }, 500);
        });
        vm.swiperInstance.on('loopFix', () => {
            vm.swiperInstance.update();
        });
        vm.swiperInstance.on('observerUpdate', vm.updateSwiper);
        for (const eventName in vm.$listeners) {
            vm.swiperInstance.on(getFormattedEventName(eventName), function (Swiper, Event) {
                const response = [];
                if (Swiper)
                    response.push(Swiper);
                if (Event)
                    response.push(Event);
                vm.$emit(eventName, ...response);
            });
        }
    }
});
